import {RegionEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback, useEffect, useState} from "react";

export type BaseRegionMultiSelectProps = Omit<BaseEntityMultiSelectProps<RegionEntity>, 'nameMapper'>

export const BaseRegionMultiSelect = (props: BaseRegionMultiSelectProps) => {
  const {entities, ...rest} = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback((e: RegionEntity) => {
    return e.name;
  }, []);

  useEffect(() => {
    const sortedRegions = entities.sort((a, b) =>
      nameMapper(a).localeCompare(nameMapper(b))
    );
    setSortedData(sortedRegions);
  }, [entities, nameMapper]);

  return <BaseEntityMultiSelect entities={sortedData} nameMapper={nameMapper} {...rest} />;
};
